/**
 * 세션 스토리지 서비스
 * prefix와 JSON 파싱을 적용하여 앱 전역에서 일관되게 사용합니다.
 */
class SessionStorageService {
    constructor() {
        Object.defineProperty(this, "STORAGE_KEY_PREFIX", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'moda_sessionstorage_'
        });
    }
    setItem(key, value) {
        if (typeof window === 'undefined')
            return;
        sessionStorage.setItem(this.STORAGE_KEY_PREFIX + key, JSON.stringify(value));
    }
    getItem(key, includePrefix = true) {
        if (typeof window === 'undefined')
            return null;
        const fullKey = includePrefix ? this.STORAGE_KEY_PREFIX + key : key;
        const item = sessionStorage.getItem(fullKey);
        if (item === null)
            return null;
        try {
            return JSON.parse(item);
        }
        catch {
            return item;
        }
    }
    /**
     * JSON 객체 등 비문자열 값을 sessionStorage에서 복원합니다.
     * @param key - 논리 키 (prefix는 자동 적용)
     * @returns 파싱된 값, 없거나 실패 시 null
     */
    getParsedItem(key) {
        if (typeof window === 'undefined')
            return null;
        const fullKey = this.STORAGE_KEY_PREFIX + key;
        const item = sessionStorage.getItem(fullKey);
        if (item === null)
            return null;
        try {
            return JSON.parse(item);
        }
        catch {
            return null;
        }
    }
    removeItem(key) {
        if (typeof window === 'undefined')
            return;
        sessionStorage.removeItem(this.STORAGE_KEY_PREFIX + key);
    }
    clearStorage() {
        if (typeof window === 'undefined')
            return;
        sessionStorage.clear();
    }
}
export const sessionStorageService = new SessionStorageService();
export default sessionStorageService;
//# sourceMappingURL=session-storage.service.js.map